// extracted by mini-css-extract-plugin
export const header = "header-module--header--5oL8Z";
export const headerTitle = "header-module--header-title--E8qHh";
export const title = "header-module--title--33_Mw";
export const nameSpan = "header-module--name-span--24Rcv";
export const navList = "header-module--nav-list--3iDqA";
export const navItem = "header-module--nav-item--3z3jX";